import { render } from "./LeadershipIncome.vue?vue&type=template&id=6246245e&scoped=true"
import script from "./LeadershipIncome.vue?vue&type=script&lang=js"
export * from "./LeadershipIncome.vue?vue&type=script&lang=js"

import "./LeadershipIncome.vue?vue&type=style&index=0&id=6246245e&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6246245e"]])

export default __exports__